var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgShowerRain = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      fill: "var(--color--primary-text)"
    },
    viewBox: "0 0 60.031 60.05",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.11,38.979l.05-.068a.075.075,0,0,0,0-.065.08.08,0,0,0-.04-.05,11.257,11.257,0,0,1,5.338-21.278h0a2.5,2.5,0,0,0,2.467-2.086,12.508,12.508,0,0,1,24.133-2.079,2.5,2.5,0,0,0,2.251,1.669,6.254,6.254,0,0,1,5.584,8.418,2.5,2.5,0,0,0,.916,2.924,7.5,7.5,0,0,1-.39,12.575v.028h0q1.311,1.9,2.344,3.617a.615.615,0,0,0,.405.288.625.625,0,0,0,.5-.1A12.508,12.508,0,0,0,56.318,23.61a.63.63,0,0,1-.178-.545,11.509,11.509,0,0,0,.14-1.794,11.235,11.235,0,0,0-8.8-10.989.62.62,0,0,1-.428-.34,17.511,17.511,0,0,0-32.491,2.291.628.628,0,0,1-.513.433,16.26,16.26,0,0,0-6.1,30.082.623.623,0,0,0,.856-.213Q9.819,40.846,11.11,38.979Z",
    transform: "translate(-0.003 0.005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.509,24.468c0-3.2-3.807-9.058-5.446-11.427a2.6,2.6,0,0,0-4.118,0C13.307,15.41,9.5,21.271,9.5,24.468a7.5,7.5,0,1,0,15.009,0Zm-10.006,0a15.165,15.165,0,0,1,1.956-4.435.63.63,0,0,1,1.091,0,15.18,15.18,0,0,1,1.956,4.435,2.5,2.5,0,1,1-5,0Z",
    transform: "translate(14.257 18.071)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.064,17.041a2.6,2.6,0,0,0-4.118,0C19.307,19.41,15.5,25.271,15.5,28.468a7.5,7.5,0,0,0,15.009,0C30.509,25.271,26.7,19.41,25.064,17.041ZM23,30.97a2.5,2.5,0,0,1-2.5-2.5,15.165,15.165,0,0,1,1.956-4.435.63.63,0,0,1,1.091,0,15.18,15.18,0,0,1,1.956,4.435A2.5,2.5,0,0,1,23,30.97Z",
    transform: "translate(23.267 24.077)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.064,17.041a2.6,2.6,0,0,0-4.118,0C7.307,19.41,3.5,25.271,3.5,28.468a7.5,7.5,0,0,0,15.009,0C18.509,25.271,14.7,19.41,13.064,17.041ZM11,30.97a2.5,2.5,0,0,1-2.5-2.5,15.165,15.165,0,0,1,1.956-4.435.63.63,0,0,1,1.091,0,15.18,15.18,0,0,1,1.956,4.435A2.5,2.5,0,0,1,11,30.97Z",
    transform: "translate(5.248 24.077)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShowerRain, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/shower_rain.905dde3f.svg";
export { ForwardRef as ReactComponent };